module.exports = __webpack_public_path__ + "img/62ABITO-SUGAR-XSSM-RIC.GRECIA-RIC.LIMONE-STAMPE-LINO4.d3f2f604.jpg";